import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAssessment, ISection, IQuestion, IRisk, IReward } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-question-help',
  templateUrl: './question-help.component.html',
})
export class QuestionHelpComponent implements OnInit {

  question: IQuestion = {
    section: 0,
    id: 0,
    xref: '00000000-0000-0000-0000-000000000000',
    title: '',
    description: '',
    risk_id: 0,
    risk_trigger: 0,
    reward_id: 0,
    reward_trigger: 0,
    progress: 0,
    notes: '',
  };
  tabs: object[];
  tabitems: object[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private message: MessageService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    const q = this.service.getQuestion();
    if (q) {
      this.question = q;
    } else {
      this.closePopup();
      return;
    }

    window.scroll(0, 0);

    this.service.getHttpQuestionHelp(this.question.section, this.question.id)
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Populate help modal on footer
   */
  private handleSuccess(resp: HttpResponse<any>) {
    let lastSlug = '';
    for (const h of resp.body) {
      if (! this.tabs) {
        this.tabs = [{
          slug: h.help_type.slug,
          title: h.help_type.title,
          description: h.help_type.description
        }];
        lastSlug = h.help_type.slug;
      } else if (h.help_type.slug !== lastSlug) {
        this.tabs.push({
          slug: h.help_type.slug,
          title: h.help_type.title,
          description: h.help_type.description
        });
        lastSlug = h.help_type.slug;
      }
      const tabitem = {
        help_type: h.help_type.slug,
        title: h.title,
        description: h.description
      };
      if (! this.tabitems) {
        this.tabitems = [tabitem];
      } else {
        this.tabitems.push(tabitem);
      }
    }
  }

  closePopup() {
    // Providing a `null` value to the named outlet
    // clears the contents of the named outlet
    this.router.navigate([{ outlets: { popup: null }}]);
  }
}
